import type {Component, Editor} from 'grapesjs';
import {findCountdownComponents, isCountdownComponent, updateCountdownDigitsInDom} from '@EmailMakerReact/lib/email-maker-countdown-library';
import {COUNTDOWN_TICK_INTERVAL_MS} from '@EmailMakerReact/lib/email-maker-countdown-library.types';

export function initCountdownTicker(editor: Editor): () => void {
  let intervalId: number | null = null;

  const stop = (): void => {
    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  const tick = (): void => {
    const countdowns = findCountdownComponents(editor);
    if (countdowns.length === 0) {
      stop();
      return;
    }
    if (document.hidden) {
      return;
    }
    countdowns.forEach(updateCountdownDigitsInDom);
  };

  const start = (): void => {
    intervalId ??= window.setInterval(tick, COUNTDOWN_TICK_INTERVAL_MS);
  };

  const onComponentMount = (component: Component): void => {
    if (isCountdownComponent(component)) {
      start();
    }
  };

  editor.on('component:mount', onComponentMount);
  editor.on('load', start);
  editor.on('undo redo', tick);

  return (): void => {
    stop();
    editor.off('component:mount', onComponentMount);
    editor.off('load', start);
    editor.off('undo redo', tick);
  };
}
